import type { AuthUser } from '@/api/authUser';
import { normalizeAuthUser } from '@/api/authUser';

const STORAGE_KEY = 'amz_app_session';

export type AppUser = AuthUser;

export type StoredAuthSession = {
  accessToken: string;
  refreshToken: string | null;
  user: AppUser;
};

function parseStoredUser(raw: unknown): AppUser | null {
  if (!raw || typeof raw !== 'object') return null;
  const u = raw as Record<string, unknown>;
  const id = typeof u.id === 'string' ? u.id : null;
  if (!id) return null;
  return normalizeAuthUser(u);
}

export function getStoredSession(): StoredAuthSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') return null;
    const p = parsed as Record<string, unknown>;
    const accessToken = typeof p.accessToken === 'string' ? p.accessToken : null;
    const refreshToken = typeof p.refreshToken === 'string' ? p.refreshToken : null;
    const user = parseStoredUser(p.user);
    if (!accessToken || !user) return null;
    return {
      accessToken,
      refreshToken,
      user,
    };
  } catch {
    return null;
  }
}

export function setStoredSession(session: StoredAuthSession): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      accessToken: session.accessToken,
      refreshToken: session.refreshToken,
      user: session.user,
    })
  );
}

export function clearStoredSession(): void {
  localStorage.removeItem(STORAGE_KEY);
}
